<template>
  <b-modal
    v-model="show"
    title="Profit Loss Entry History"
    size="lg"
    hide-footer
    @shown="fetchHistory"
  >
    <div v-if="loading" class="text-center my-4">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
    <div v-else>
      <div v-if="error" class="alert alert-danger">{{ error }}</div>
      <div class="d-flex justify-content-end mb-2" v-if="historyData.length > 0">
        <b-button variant="success" size="sm" @click="exportToExcel">
          <i class="fa fa-file-excel-o"></i> Export to Excel
        </b-button>
      </div>
      <b-table
        :items="historyData"
        :fields="fields"
        striped
        hover
        responsive
        show-empty
      >
        <template slot="empty">
          <div class="text-center text-muted my-2">
            No history records found for the current month.
          </div>
        </template>
        <template slot="createdCount" slot-scope="data">
          <span :class="{'text-success font-weight-bold': data.value > 0}">{{ data.value }}</span>
        </template>
         <template slot="updatedCount" slot-scope="data">
          <span :class="{'text-info font-weight-bold': data.value > 0}">{{ data.value }}</span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import ProfitLossService from "../../services/ProfitLossService";
import * as XLSX from "xlsx";

export default {
  name: "ProfitLossHistoryModal",
  data() {
    return {
      show: false,
      loading: false,
      error: "",
      historyData: [],
      fields: [
        { key: "date", label: "Date", sortable: true },
        { key: "day", label: "Day", sortable: false },
        { key: "year", label: "Year", sortable: false },
        { key: "createdCount", label: "Entries Created", sortable: true, class: "text-center" },
        { key: "updatedCount", label: "Entries Updated", sortable: true, class: "text-center" },
      ],
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    async fetchHistory() {
      this.loading = true;
      this.error = "";
      this.historyData = [];
      try {
        const response = await ProfitLossService.getProfitLossCountsByDate({});
        if (response.data && response.data.data) {
          this.historyData = response.data.data;
        } else {
             // Fallback if data structure is different
             this.historyData = response.data || [];
        }
      } catch (err) {
        console.error("Error fetching profit loss history:", err);
        this.error = "Failed to load history data.";
      } finally {
        this.loading = false;
      }
    },
    exportToExcel() {
      if (this.historyData.length === 0) return;

      const dataToExport = this.historyData.map(item => ({
        "Date": item.date,
        "Day": item.day,
        "Year": item.year,
        "Entries Created": item.createdCount,
        "Entries Updated": item.updatedCount
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Profit Loss History");
      
      const fileName = `Profit_Loss_History_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(wb, fileName);
    }
  },
};
</script>



// WEBPACK FOOTER //
// ProfitLossHistoryModal.vue?07d5043e